const DEFAULT_BASE_URL = process.env.REACT_APP_API_URL !== undefined
  ? process.env.REACT_APP_API_URL
  : 'http://localhost:5143';

export function getSettings() {
  return {
    baseUrl: localStorage.getItem('seikoauth_base_url') || DEFAULT_BASE_URL,
    apiKey: localStorage.getItem('seikoauth_api_key') || '',
  };
}

export function saveSettings({ baseUrl, apiKey }) {
  localStorage.setItem('seikoauth_base_url', baseUrl);
  localStorage.setItem('seikoauth_api_key', apiKey);
}

function buildHeaders() {
  const { apiKey } = getSettings();
  return {
    'Content-Type': 'application/json',
    'X-Admin-Key': apiKey,
  };
}

async function request(path, options = {}) {
  const { baseUrl } = getSettings();
  const res = await fetch(`${baseUrl}${path}`, {
    ...options,
    headers: buildHeaders(),
  });
  if (res.status === 204) return null;
  if (!res.ok) {
    let msg = res.statusText;
    try {
      const data = await res.json();
      msg = data.error || msg;
    } catch (_) {}
    throw new Error(msg);
  }
  return res.json();
}

export const clientsApi = {
  getAll: () => request('/admin/clients'),
  create: (dto) => request('/admin/clients', { method: 'POST', body: JSON.stringify(dto) }),
  update: (id, dto) => request(`/admin/clients/${id}`, { method: 'PUT', body: JSON.stringify(dto) }),
  delete: (id) => request(`/admin/clients/${id}`, { method: 'DELETE' }),
  rotateSecret: (id) => request(`/admin/clients/${id}/rotate-secret`, { method: 'POST' }),
  toggleActive: (id) => request(`/admin/clients/${id}/toggle-active`, { method: 'POST' }),
};

export const scopesApi = {
  getAll: () => request('/admin/scopes'),
  create: (dto) => request('/admin/scopes', { method: 'POST', body: JSON.stringify(dto) }),
  update: (id, dto) => request(`/admin/scopes/${id}`, { method: 'PUT', body: JSON.stringify(dto) }),
  delete: (id) => request(`/admin/scopes/${id}`, { method: 'DELETE' }),
};
